import styled from 'styled-components/macro';
import {MenuItem} from "@chakra-ui/react";
import NavLink from "../nav_link";
import {Archive, Clock, Rocket, TrendingDown} from "lucide-react";

const CommentSortMenu = styled(({className, sort}) => {
    return (
        <div className={className}>
            <NavLink href={`?commentSort=top`} react_route>
                <MenuItem minH='40px'>
                    <Rocket size={18} />
                    <span>Top</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`?commentSort=new`} react_route>
                <MenuItem minH='40px'>
                    <Clock size={18} />
                    <span>New</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`?commentSort=controversial`} react_route>
                <MenuItem minH='40px'>
                    <TrendingDown size={18} />
                    <span>Worst</span>
                </MenuItem>
            </NavLink>
            <NavLink href={`?commentSort=old`} react_route>
                <MenuItem minH='40px'>
                    <Archive size={18} />
                    <span>Old</span>
                </MenuItem>
            </NavLink>
        </div>
    );
})`
  svg {
    margin: 0 16px 0 8px;
  }
`;

export default CommentSortMenu;
